import React, { ReactNode, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useParams } from 'react-router'
import clsx from 'clsx'
import { PARAM } from '@App/navigation/param'
import ContentHeader from '@Components/ContentHeader'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import WorkMergeRequestDetailStore from '@App/stores/rightsholder/workMerge/work-merge-request-detail-store'
import { WorkMergeRequestDetail } from '@Entities/rightsholder/work-merge'
import '@Scenes/RightsholderScene/WorkMerge/index.scss'
import './index.scss'

interface WorkMergeRequestPageProps {
    store: WorkMergeRequestDetailStore
    className: string
    children: (request: WorkMergeRequestDetail) => ReactNode
}

const WorkMergeRequestPage = ({ store, className, children }: WorkMergeRequestPageProps) => {
    const params = useParams<typeof PARAM>()
    const workMergeRequestId = Number(params.workMergeRequestId)

    useEffect(() => {
        if (!Number.isNaN(workMergeRequestId)) {
            store.loadRequest(workMergeRequestId)
        }

        return () => {
            store.clearCurrentRequest()
        }
    }, [params.workMergeRequestId])

    const request = store.currentRequest

    return (
        <div className="work-merge-wrapper">
            <ContentHeader title="Work Merge Request Tool" />
            <div className={clsx('work-merge-request-page', className)}>
                {store.isLoading && <PointPreloader />}
                {!store.isLoading && !request && (
                    <p className="work-merge-request-page-empty">This merge request could not be found.</p>
                )}
                {!store.isLoading && request && children(request)}
            </div>
        </div>
    )
}

export default observer(WorkMergeRequestPage)
